module.exports = {
  siteTitle: 'Ishank Singh | Android Developer',
  siteDescription:
    'Ishank Singh is an Android developer based in Bengaluru, IN specializing in building (and occasionally designing) exceptional, visually pleasing, high-quality apps.',
  siteKeywords: 'Ishank Singh, Ishank, Singh, ishdemon, software engineer, Android engineer',
  siteUrl: 'https://whoishdemon.netlify.com',
  siteLanguage: 'en_US',

  name: 'Ishank Singh',
  location: 'Bengaluru, IN',
  email: 'ishdemon10@gmail.com',
  socialMedia: [
    {
      name: 'Github',
      url: 'https://github.com/ishdemon/',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/bchiang7/',
    },
    {
      name: 'Codepen',
      url: 'https://codepen.io/bchiang7/',
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/bchiang7/',
    },
    {
      name: 'Twitter',
      url: 'https://twitter.com/bchiang7',
    },
  ],

  nav: [
    {
      name: 'About',
      url: '#about',
    },
    {
      name: 'Experience',
      url: '#jobs',
    },
    {
      name: 'Work',
      url: '#projects',
    },
    {
      name: 'Contact',
      url: '#contact',
    },
  ],

  twitterHandle: '@bchiang7',

  headerHeight: 100,

  greenColor: '#64ffda',
  navyColor: '#0a192f',
  darkNavyColor: '#020c1b',

  srConfig: (delay = 200) => {
    return {
      origin: 'bottom',
      distance: '20px',
      duration: 500,
      delay,
      rotate: { x: 0, y: 0, z: 0 },
      opacity: 0,
      scale: 1,
      easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
      mobile: true,
      reset: false,
      useDelay: 'always',
      viewFactor: 0.25,
      viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
    };
  },
};
